module.exports = __webpack_public_path__ + "img/bg-coins2.da7a8136.png";